import { Injectable } from '@angular/core';
import { ofType, Actions, createEffect } from '@ngrx/effects';
import { of, throwError } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { EMsidnListActions, GetMsisdnList, GetMsisdnListSuccess, GetMsisdnListFailure } from '../actions/msidn-list.actions';
import { LinesService } from '../../services/lines.service';
import { Store } from '@ngrx/store';
import { HttpErrorResponse } from '@angular/common/http';
import { AbstractEffects } from '../../../shared/abstract.effects';
import { MsisdnListInterface } from '../../models/msisdn-list.interface';

@Injectable()
export class MsisdnListEffects extends AbstractEffects {

    constructor(
      private actions: Actions,
      private linesService: LinesService,
      public override store: Store<any>
    ) {
        super(store);
    }

    getMsisdnList = createEffect(() => this.actions.pipe(
        ofType<GetMsisdnList>(EMsidnListActions.GetMsisdnList),
        switchMap(() => this.linesService.getMsisdnList()),
        switchMap((response: Array<MsisdnListInterface>) => of(new GetMsisdnListSuccess(response))),
        catchError((error: HttpErrorResponse) => {
            if (401 === error.status || 403 === error.status) {
                this.ResendRequestWithNewToken(new GetMsisdnList());
            } else {
                this.DisplayMessage('error_with_retry', 400, new GetMsisdnListFailure());
            }
            return throwError(error);
        })
    ));
}
